/**
 * URL 工具
 */
const URL = {};
const search = window.location.search;
/**
 * 根据key获取浏览器url param值，不存在返回空字符串
 * @param key
 * @returns {*}
 */
URL.getParameterByKey = (key) => {
  const query = search.substring(1);
  const params = query.split('&');
  const res = params.filter((param) => param.indexOf(`${key}=`) === 0);
  if (res.length) {
    return res[0].split('=')[1];
  }
  return '';
};

URL.isWXApplet = URL.getParameterByKey('wxapplet') === 'true' || sessionStorage.getItem('wxapplet') === 'true';
sessionStorage.setItem('wxapplet', URL.isWXApplet ? 'true' : '');
Object.freeze(URL);

export default URL;
